<template>
  <div>
    <component v-for="(block, i) in content" :is="block.acf_fc_layout" :key="i + 1" :content="block.content" class="content-section"></component>
  </div>
</template>

<script>
import wysiwyg from '../Content/WYSIWYG.vue'
import accordion from '../Content/Accordion.vue'
import slideshow from '../Content/Slideshow.vue'

export default {
  name: 'Content',
  props: ['content'],
  components: { wysiwyg, accordion, slideshow }
}
</script>
